module.exports = __webpack_public_path__ + "assets/img/backt.6b0c78bf.png";